import { Draggable } from 'apps/studio/components/dragAndDrop/Draggable'
import { getTableDisplayMetrics } from 'apps/studio/lib/utils/entities'

export const getResizingPreviewPosition = ({
  position,
  targetType = 'element',
  tableLayout,
}) => {
  if (targetType !== 'table') return position

  const { displayHeight } = getTableDisplayMetrics({
    ...tableLayout,
    position,
  })

  return {
    ...position,
    height: displayHeight,
  }
}

export const applyResizingStyles = (element, position) => {
  element.style.setProperty('--local-resizing-width', `${position.width}px`)
  element.style.setProperty('--local-resizing-height', `${position.height}px`)
  element.style.setProperty('--local-resizing-x', `${position.x}px`)
  element.style.setProperty('--local-resizing-y', `${position.y}px`)
}

export const removeResizingStyles = element => {
  element.style.removeProperty('--local-resizing-width')
  element.style.removeProperty('--local-resizing-height')
  element.style.removeProperty('--local-resizing-x')
  element.style.removeProperty('--local-resizing-y')
}

export const ResizeHandle = ({
  position,
  handleLocation,
  wrapperId,
  entry,
  targetType = 'element',
  tableLayout,
}) => {
  const targetId = targetType === 'table' ? `table-${tableLayout.id}` : entry.guid
  return (
    <Draggable
      id={`${handleLocation}-${targetId}`}
      classes={`resize--handle resize--${handleLocation}`}
      data={{
        type: 'resizeHandle',
        targetType,
        position,
        handleLocation,
        entry,
        tableLayout,
        wrapperId,
      }}
    />
  )
}
